const state = {
  navigation: {
    tabs: [
      {
        id: 1,
        title: 'Page par défaut',
        link: null
      }
    ],
    active: 1
  },
  tables: {
    clients: {
      columns: {
        name: true,
        address: true,
        company_contacts: true,
        contact_contacts: true,
        services: true,
        analysis: true,
        invoicing: false
      }
    }
  },
  forms: {
    client_list: {},
    prospect_list: {}
  }
}

const getters = {
  navigation: state => state.navigation
}

export default {
  namespaced: true,
  state,
  getters
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/account/user_session.js